
import 'es6-promise/auto'

import Vue from 'vue';
import Vuex from 'vuex'
import App from './App.vue';
import router from './router';
import Amplify, * as AmplifyModules from 'aws-amplify';
import { AmplifyPlugin } from 'aws-amplify-vue';
import awsconfig from './aws-exports';
import store from './store.js'; 
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@mdi/js';
import Datetime from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { AmplifyEventBus } from 'aws-amplify-vue';

Vue.use(Vuetify, {
  icons: {
    iconfont: 'mdiSvg',
  },
    theme: { 
      primary: "#6400aa", 
      secondary: "#3900aa",
      accent: "#1976D2",
      error: "#f47742",
      tertiary: "#073b4c",
      dev: "#000000"
    }
  });

Vue.use(AmplifyPlugin, AmplifyModules, Vuex, AmplifyEventBus, Datetime);

Amplify.configure(awsconfig);

new Vue({   
  el: ('#app'),
  router, 
  store: store,
  render: h => h(App)
});


